import { render, staticRenderFns } from "./PortfolioStatusComponent.vue?vue&type=template&id=4d8e2a96&scoped=true&"
import script from "./PortfolioStatusComponent.vue?vue&type=script&lang=js&"
export * from "./PortfolioStatusComponent.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioStatusComponent.vue?vue&type=style&index=0&id=4d8e2a96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e2a96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VChip,VCol,VContainer,VRow,VSimpleTable})
